<template>
  <div class="navbar__links">
    <div
      v-for="item in menuItems"
      :key="item"
      class="navbar__link"
      :class="{active: activeItem === item}"
      v-on:click="onMenuClick(item)"
    >
      {{item}}
    </div>
  </div>
</template>

<script>
import { JACKET_MENU } from '@/common/constants';

export default {
  name: 'EditorNavigation',

  props: {
    menuItems: Array,
    activeItem: String
  },
  computed: {
    jacketSide () {
      return this.$store.getters['ui/getJacketSide'];
    },
  },
  watch: {
    jacketSide () {
      this.$store.dispatch('ui/setActiveMenuItem', {
        page: 'jacket',
        menuItem: JACKET_MENU.JACKET
      });
    },
  },
  methods: {
    onMenuClick (item) {
      this.$store.dispatch('ui/setActiveMenuItem', {
        page: 'jacket',
        menuItem: item
      });
    },
  }
};
</script>

<style scoped>
  .navbar__links {
    background: #cbcaca;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    z-index: 10;
  }

  .navbar__link {
    width: 100%;
    padding: 10px;

    font-size: 18px;
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
    color: #231f20;

    border-right: 1px solid #fff;
    background: transparent;

    cursor: pointer;
    transition: 0.25s ease-in-out all;
  }

  .navbar__link:last-child {
    width: calc(100% + 1px);
    border: none;
  }

  .navbar__link.active {
    background: #1c539c;
    color: #fff;

    pointer-events: none;
  }

  .navbar__link:hover,
  .link-hover:hover {
    background: #7aa3d8;
    color: #fff;
    cursor: pointer;
  }
</style>
